export default {
  en: {
    PackagerHistory: {
      title: 'My packages',
    },
  },
};
